import React, { useMemo, useState } from 'react';
import { Modal, Form } from 'react-bootstrap';
import { stepTypes } from './StepPalette';
import './StepTypePickerModal.css';

const sortedStepTypes = [...stepTypes].sort((a, b) => a.label.localeCompare(b.label));

function StepTypePickerModal({ show, title, onSelect, onCancel }) {
  const [filter, setFilter] = useState('');

  const filteredTypes = useMemo(() => {
    const query = filter.trim().toLowerCase();
    if (!query) return sortedStepTypes;
    return sortedStepTypes.filter((stepType) => stepType.label.toLowerCase().includes(query));
  }, [filter]);

  const handleHide = () => {
    setFilter('');
    onCancel();
  };

  const handleSelect = (stepType) => {
    setFilter('');
    onSelect(stepType);
  };

  return (
    <Modal show={show} onHide={handleHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Control
          type="text"
          placeholder="Filter steps…"
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          className="mb-2"
          autoFocus
        />
        <div className="step-type-picker-list">
          {filteredTypes.map((stepType) => (
            <button
              key={stepType.type}
              type="button"
              className="step-type-picker-item"
              onClick={() => handleSelect(stepType)}
            >
              <span className="step-type-picker-icon">{stepType.icon}</span>
              <span className="step-type-picker-text">
                <span className="step-type-picker-label">{stepType.label}</span>
                {stepType.description && (
                  <span className="step-type-picker-description">{stepType.description}</span>
                )}
              </span>
            </button>
          ))}
          {filteredTypes.length === 0 && (
            <div className="text-muted small px-2 py-3">No matching steps.</div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default StepTypePickerModal;
